import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOverflowVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 5,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 19,
			r: 1.5,
			fill: "currentColor"
		})
	]
});
export { SvgIconOverflowVertical as ReactComponent };
